import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../../widgets/form/InputSelectUI'

const LoanMappingUpdateModalUI = ({ loan, context, successMsg, errorList, setErrorList,
    // sourceValue
    sourceValue, onSourceValueChange, sourceValueError, setSourceValueError,
    // superuser role
    mappedValue, mappedValueError, onMappedValueChange, setMappedValueError,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
}) =>
    <ModalFormUI
        loan={loan}
        context={context}
        titleLabel='Update mappings'
        buttonLabel='Update'
        cancelLabel='Cancel'
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputTextSF type='text' name='sourceValue' label='Label' maxLength={100}
            value={sourceValue} onChange={onSourceValueChange}
            error={sourceValueError} setError={setSourceValueError}
            autoFocus={true} help='Remove labels to delete this entry'
        />
        <InputTextSF type='text' name='mappingValue' label='Value' maxLength={100}
            value={mappedValue} onChange={onMappedValueChange}
            error={mappedValueError} setError={setMappedValueError}
        />
    </ModalFormUI>

export default LoanMappingUpdateModalUI
